<template>
    <div class="privacy-policy">
      <h4 class="text-center">Политика обработки персональных данных</h4>
      <p class="text-right">г. Москва, {{ currentDate }}</p>
  
      <div class="document-body">
        <p>Настоящая Политика конфиденциальности персональных данных Посетителей сайта (далее – «Политика») утверждена ООО «ТАНАИС Брокер», (далее — «Компания») и действует в отношении всей информации, которую Компания может получить о Посетителях сайта https://b2b.tanais.tech с любого устройства и при коммуникации с Компанией в любой форме.</p>
  
        <p>Используя Cайты Компании (просмотр, чтение текста, отправка или загрузка информации) и предоставляя свои персональные данные, Посетитель сайта дает согласие на обработку персональных данных в соответствии с данной Политикой.</p>
  
        <h5>Понятия и состав персональных данных</h5>
        <p>персональные данные – любая информация, относящаяся прямо или косвенно к определенному или определяемому физическому лицу (субъекту персональных данных);</p>
        <p>обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемое с использованием средств автоматизации или без их использования.</p>
        <p>Компания производит обработку персональных данных Посетителя сайта, включая фамилию, имя, отчество, дату и место рождения, контактный телефон, реквизиты документа, удостоверяющего личность, адрес регистрации, адрес электронной почты, адрес доставки и др.</p>
        <p>Компания осуществляет обработку персональных данных способом сбора, систематизации, накопления, хранения, уточнения (обновления, изменения), использования, распространения (в том числе передачи), обезличивания, блокирования, уничтожения.</p>
  
        <h5>Законодательные и иные нормативные правовые акты</h5>
        <ul class="disc-lists">
            <li>Конституция РФ</li>
            <li>Гражданский кодекс РФ</li>
            <li>Федеральный закон от 30.06.2003 г. №87-ФЗ «О транспортно-экспедиционной деятельности»</li>
            <li>Федеральный закон от 27.07.2006 г. № 152-ФЗ «О персональных данных»</li>
            <li>Федеральный закон от 27.07.2006 г. №149-ФЗ «Об информации, информационных технологиях и о защите информации»</li>
        </ul>
  
        <h5>Технологии «cookies»</h5>
        <p>Cookies – небольшие по размеру текстовые файлы, хранящиеся в браузере Посетителей сайта.</p>
        <p>На совокупности различных веб-проектов Компании (при просмотре веб-сайтов) происходит автоматический сбор (из Cookies) следующих обезличенных статистических данных о Посетителе сайта:</p>
        <ul class="disc-lists">
          <li>тип выполненного на сайте действия (клик, наведение курсора и т.п.);</li>
          <li>дата и время выполнения действия;</li>
          <li>URL страницы;</li>
          <li>Referer;</li>
          <li>IP (без возможности работы с IP-адресами в статистике);</li>
          <li>User-Agent;</li>
          <li>ClientID (идентификатор браузера по файлу Cookie);</li>
          <li>экранное разрешение;</li>
          <li>класс HTML-элемента, на который происходит клик;</li>
          <li>данные о содержании, стоимости, статусе доставки отправлений, сопровождаемых Компанией;</li>
          <li>данные о фактах заполнения форм на Сайте Компании, включая ошибки при их заполнении.</li>
        </ul>
        <p>Пользуясь Сайтом Компании, Посетитель соглашается на то, что Компания может использовать статистические данные и файлы Cookies для их последующей обработки системами Google Analytics, Яндекс.Метрика, и может передавать третьему лицу для проведения исследований, выполнения работ или оказания услуг по поручению Компании.</p>
        <p>Посетитель сайта может самостоятельно управлять файлами Cookies путем изменения настроек браузера. Изменения пользовательских настроек, в результате которых файлы Cookies будут заблокированы, могут привести к недоступности отдельных компонентов сайтов Компании.</p>
        <p>Пользуясь Сайтом Компании, в том числе при заполнении веб-форм на Сайте, Посетитель Сайта соглашается на получение рекламы, а также использование сведений о нем в целях продвижения услуг Компании и третьих лиц.</p>
  
        <h5>Принципы обработки персональных данных</h5>
        <p>Обработка персональных данных осуществляется с учетом необходимости обеспечения защиты прав и свобод субъектов персональных данных, включая:</p>
        <ul class="disc-lists">
          <li>обработка персональных данных осуществляется на законной основе;</li>
          <li>Компания обеспечивает соблюдение принципов и правил обработки персональных данных, указанных в ст. 5 ФЗ-152 «О персональных данных»;</li>
          <li>обработка персональных данных ограничивается достижением конкретных целей;</li>
          <li>не допускается обработка персональных данных, несовместимая с целями сбора;</li>
          <li>не осуществляется обработка биометрических данных;</li>
          <li>не осуществляется обработка специальных категорий персональных данных;</li>
          <li>не производится трансграничная передача данных;</li>
          <li>при обработке персональных данных принимаются меры защиты от неправомерного доступа и иных действий.</li>
        </ul>
  
        <h5>Цели сбора и обработки персональных данных</h5>
        <p>Компания обрабатывает персональные данные Посетителя исключительно в целях, для которых они предоставлялись, включая:</p>
        <ul class="disc-lists">
          <li>идентификации Посетителя сайта;</li>
          <li>посещения и авторизации в Личном кабинете;</li>
          <li>заключения договора на услуги Компании;</li>
          <li>предоставления информации о Компании и услугах;</li>
          <li>ознакомления с правовыми документами Компании;</li>
          <li>установления обратной связи, включая направление уведомлений и запросов;</li>
          <li>определения локации Посетителя сайта для безопасности и удобства;</li>
          <li>подтверждения достоверности и полноты предоставленных данных;</li>
          <li>таможенного оформления заказов;</li>
          <li>отслеживания заказов;</li>
          <li>для других целей с согласия Посетителя сайта.</li>
        </ul>
  
        <h5>Права посетителя сайта</h5>
        <p>Посетитель сайта вправе реализовать свои права, включая:</p>
        <ul class="disc-lists">
          <li>уточнять, обновлять свои персональные данные, требовать их блокирования или уничтожения;</li>
          <li>запрашивать у Компании перечень обрабатываемых данных, правовые основания, источники их получения, сроки обработки и хранения.</li>
        </ul>
  
        <h5>Срок обработки персональных данных</h5>
        <p>Посетитель сайта дает согласие на обработку своих персональных данных на весь срок, необходимый Компании для достижения целей обработки.</p>
        <p>Посетитель сайта вправе в любое время отозвать согласие путем направления письменного заявления по адресу: 121596 г. Москва, ул. Горбунова, дом 2, строение 3, офис B403.</p>
  
        <h5>Заключительные положения</h5>
        <p>Компания вправе вносить изменения или дополнения в настоящую Политику, а также в случае изменений законодательства РФ о персональных данных.</p>
        <p>Посетитель сайта всегда может ознакомиться с актуальной версией Политики на сайте Компании. Продолжая пользоваться сайтами Посетитель подтверждает согласие с внесенными изменениями.</p>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: "PrivacyPolicy",
    data() {
      return {
        currentDate: new Date().toLocaleDateString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        })
      };
    }
  };
</script>
  
<style scoped>
    .privacy-policy {
        max-width: 900px;
        margin: 0 auto;
        font-family: Arial, sans-serif;
        line-height: 1.6;
        font-size: 14px;
    }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
    h5 { margin-top: 24px; margin-bottom: 8px; }
    ul { margin: 8px 0 8px 20px; }
    .document-body p { margin: 8px 0; }
</style>